<p-date-picker
  [dateFormat]="DATE_RANGE_FORMAT"
  [fluid]="true"
  [formControl]="control"
  [showButtonBar]="true"
  [showTime]="showTime"
  placeholder="Wybierz zakres dat"
  selectionMode="range" />
